import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-speakers',
    templateUrl: './speakers.component.html',
    styleUrls: ['./speakers.component.scss'],
    standalone: false
})
export class SpeakersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
